export default __webpack_public_path__ + "9964b2db2c3b88a476e15e0b983a3828.png";